<template>
	<ListItem is-recipient info>
		<template #text>
			<div class="font-weight-bold">{{ disclosedData.nameWithSalutation }}</div>
			<div class="font-weight-bold">{{ disclosedData.yearOfBirth }}</div>
		</template>
	</ListItem>
</template>

<script>
import ListItem from "@/vue/communication/conversation/message/ListItem";

export default {
	components: {ListItem},

	props: {
		disclosedData: {
			type: Object,
			required: true
		}
	}
}
</script>